import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=29100cb1&"
import script from "./ServiceView.vue?vue&type=script&lang=ts&"
export * from "./ServiceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports